import { Global, css } from '@emotion/react'
import emotionReset from 'emotion-reset'

export const GlobalStyle = () => (
  <Global
    styles={css`
      ${emotionReset}
      li {
        list-style: none;
      }
      /* ==== 0. 基本設定 ==== */
      html {
        font-size: 62.5%; /* 1rem = 10px */
        font-family: 'Noto Sans JP', 'Roboto', 'Helvetica Neue', sans-serif;
        scroll-behavior: smooth;
      }
      body {
        margin: 0;
        padding: 0;
        font-size: 1.6rem; /* 16px */
        line-height: 1.5;
        color: #333;
        background-color: #f5f5f5;
      }

      /* ==== 1. Reset CSS 基本リセット ==== */
      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      img {
        display: block;
        max-width: 100%;
        height: auto;
      }

      a {
        text-decoration: none;
        color: inherit;
      }

      button {
        background: none;
        border: none;
        cursor: pointer;
        font: inherit;
        padding: 0;
      }

      input,
      textarea,
      select {
        font: inherit;
        font-size: 1.6rem;
        color: inherit;
        border: none;
        outline: none;
      }

      ul,
      ol {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      table {
        border-collapse: collapse;
        width: 100%;
      }
    `}
  />
)
